import { IEditModGroupRestaurantPropertiesState } from './editModGroupRestaurantPropertiesContext';
import {
	TEditModGroupRestaurantPropertiesAction,
	EditModGroupRestaurantPropertiesActionTypes,
} from './editModGroupRestaurantPropertiesActions';

export const editModGroupRestaurantPropertiesReducer = (
	state: IEditModGroupRestaurantPropertiesState,
	action: TEditModGroupRestaurantPropertiesAction,
): IEditModGroupRestaurantPropertiesState => {
	switch (action.type) {
		case EditModGroupRestaurantPropertiesActionTypes.REFETCH_REST_PROPS_DATA:
			return {
				...state,
				needRefetchRestPropsData: action.payload.needRefetchRestPropsData,
			};
		case EditModGroupRestaurantPropertiesActionTypes.SET_ALL_DATA:
			return {
				...state,
				modGroupId: action.payload.modGroupId,
				modGroupName: action.payload.modGroupName,
				customerId: action.payload.customerId,
				customerName: action.payload.customerName,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case EditModGroupRestaurantPropertiesActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				forceDisable: action.payload.forceDisable,
				isPortionFlow: action.payload.isPortionFlow,
				parents: action.payload.parents,
				children: action.payload.children,
			};
		case EditModGroupRestaurantPropertiesActionTypes.SET_DATA_FROM_RESTAURANT:
			return {
				...state,
				forceDisable: action.payload.forceDisable,
				isPortionFlow: action.payload.isPortionFlow,
				parents: action.payload.parents,
				children: action.payload.children,
			};
		case EditModGroupRestaurantPropertiesActionTypes.TOGGLE_FORCE_DISABLE:
			return {
				...state,
				forceDisable: !state.forceDisable,
			};
		case EditModGroupRestaurantPropertiesActionTypes.SET_CHILDREN:
			return {
				...state,
				children: action.payload.children,
			};
		case EditModGroupRestaurantPropertiesActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditModGroupRestaurantPropertiesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditModGroupRestaurantPropertiesActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		default:
			return state;
	}
};
